import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'
import moment from 'moment'

import getHmac from './hmac'

export default function* requiresAuth(action) {
  const hmac = yield effects.call(getHmac)
  const expires = (hmac && hmac.get('expires')) ? moment(hmac.get('expires')) : null

  if (hmac && expires && expires.isAfter()) {
    return
  }

  yield effects.put.resolve(pushPath(`/login?returnTo=${encodeURIComponent(action.payload.returnTo)}`))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/requiresAuth.js